import React from 'react';
import { usePromptOrchestrator } from '../../hooks/usePromptOrchestrator';
import InviteFamilyNudgeCard from '../family/InviteFamilyNudgeCard';

// Renders the single dashboard prompt selected by the orchestrator, or
// nothing. PRO-348: dropped the `pwaInstall` branch — install is now
// promoted at story creation, in invitation flows, and via the
// activate-push CTA inside reminder emails. Permission recovery + the
// pre-V1 backfill banner are rendered separately by Dashboard above
// this orchestrated slot.
const ActivePrompt: React.FC = () => {
  const id = usePromptOrchestrator();

  if (id === 'audienceInvite') {
    return (
      <div className="mb-4">
        <InviteFamilyNudgeCard
          variant="dashboard"
          onInvite={() => window.dispatchEvent(new CustomEvent('openFamilyManagement'))}
        />
      </div>
    );
  }

  return null;
};

export default ActivePrompt;
